// Responsive breakpoints
var smBreakpoint = 768;
var mdBreakpoint = 992;
var lgBreakpoint = 1200;

$(document).ready(function () {
  mainMenu.init();
  hideSwiperControls.init();
  triggerSwipeboxClose.init();
  googleMapsOverlay.init();
});
